import { Upload, Button, Typography, Flex } from "antd";
import { ReactComponent as UploadIcon } from "../../../assets/Icons/uploadSvg.svg";
import React from "react";
import "./FileUpload.scss"; // SCSS will be applied here
const { Text, Link } = Typography;
const { Dragger } = Upload;
const FileUpload = ({ setFile, file }) => {
  // File upload restrictions
  const uploadProps = {
    name: "file",
    multiple: false, // Allow only one file at a time
    // accept: ".xlsx,.csv",
    beforeUpload: (file) => {
      const isSizeValid = file.size / 1024 / 1024 <= 200; // Check if file size <= 200MB
      if (!isSizeValid) {
        console.error("File must be smaller than 200MB!");
        return Upload.LIST_IGNORE; // Prevent upload if size exceeds limit
      }
      return false; // Prevent automatic upload; handle manually if needed
    },
    onChange(info) {
    
      setFile(info?.fileList?.[info?.fileList?.length - 1]);

      // Add your upload logic here (e.g., send file to server)
    },
    showUploadList: false, // Hide the default file list
  };
  // Handle download template link click
  const handleDownloadTemplate = (e) => {
    e.stopPropagation(); // Prevent default link behavior
    // Replace with actual template URL or download logic

  };


  return (
    <Flex vertical className="file_upload_container">
      <Flex className="upload_box_wrapper">
        <Flex className="file_upload_content">
          {file !== null ? (
            <Dragger {...uploadProps} className="file_upload_dragger">
              <Flex vertical className="file_upload_dragger_content">
                <Text className="file_upload_head_title">Document Upload</Text>
                <Flex className="file_upload_icon_wrapper">
                  <Text></Text>
                  <Flex className="text_wrapper">
                    <Text className="file_upload_text">{file?.name}</Text>
                  </Flex>
                </Flex>
                <Text className="file_upload_limit">
                  Limit 200MB per file | Only XLSX, CSV file
                </Text>
              </Flex>
            </Dragger>
          ) : (
            <Dragger {...uploadProps} className="file_upload_dragger">
              <Flex vertical className="file_upload_dragger_content">
                <Text className="file_upload_head_title">Document Upload</Text>
                <Flex className="file_upload_icon_wrapper">
                  <UploadIcon className="file_upload_icon" />

                  <Flex className="text_wrapper">
                    <Text className="file_upload_text">
                      Drag and drop file here or{" "}
                      <span className="blue_text">choose</span>
                    </Text>
                  </Flex>
                </Flex>
                <Text className="file_upload_limit">
                  Limit 200MB per file | Only XLSX, CSV file
                </Text>
              </Flex>
            </Dragger>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default FileUpload;
